import { Dow, RecurrentSchedule, Reservation } from '@raysee/schema';
import dayjs from 'dayjs';
import { VFC } from 'react';
import { Button, Modal } from 'rsuite';
import { useDeleteRecurrentSchedule } from '../../hooks/useDeleteRecurrentSchedule';
import { notifyScheduleError } from '../../utils/scheduleError';

interface Props {
  recurrentSchedule: RecurrentSchedule;
  reservations: Reservation[];
  isOpen: boolean;
  onClose: () => void;
}

export const DeleteRecurrentScheduleModal: VFC<Props> = (props) => {
  const { execute: deleteScheduleAction, loading: isDeleting } = useDeleteRecurrentSchedule();
  const deleteRecurrentSchedule = async (recurrentSchedule: RecurrentSchedule) => {
    const activeReservations = props.reservations
      .filter((reservation) =>
        dayjs(reservation.startTime).isBetween(
          dayjs(props.recurrentSchedule.startDate).subtract(1, 'day'),
          dayjs(props.recurrentSchedule.endDate).add(1, 'day'),
          null,
          '[]',
        ),
      )
      .filter((reservation) => {
        // 予約の曜日が定期スケジュールの曜日に含まれているかチェック
        const reservationDow = dayjs(reservation.startTime).day();
        const dowMap = ['日', '月', '火', '水', '木', '金', '土'];
        const dowString = dowMap[reservationDow];
        return recurrentSchedule.dows.includes(dowString as Dow);
      });
    if (activeReservations.length > 0) {
      const reservationList = activeReservations
        .map(
          (r) => `・${dayjs(r.startTime).format('YYYY年MM月DD日(ddd) HH:mm')}開始 ${r.user.name}`,
        )
        .join('\n');
      alert(
        `変更前の時間帯に予約が残っています。キャンセル後に再度お試しください。\n\n${reservationList}`,
      );
      return;
    }
    try {
      await deleteScheduleAction(recurrentSchedule);
    } catch (error) {
      notifyScheduleError('繰り返しシフト削除', error);
      return;
    }
    props.onClose();
  };

  return (
    <Modal show={props.isOpen} onHide={props.onClose}>
      <Modal.Header>繰り返しシフトの削除</Modal.Header>
      <Modal.Body>
        <div className="my-2">以下の設定を削除します</div>
        <div>
          <span className="mx-1">
            {dayjs(props.recurrentSchedule.startDate).format('MM/DD')}〜
            {props.recurrentSchedule.endDate
              ? dayjs(props.recurrentSchedule.endDate).format('MM/DD')
              : ''}
          </span>
          <span className="mx-1">
            {dayjs(props.recurrentSchedule.startTime).format('HH:mm')}-
            {!dayjs(props.recurrentSchedule.startTime).isSame(
              props.recurrentSchedule.endTime,
              'day',
            ) && '翌'}
            {dayjs(props.recurrentSchedule.endTime).format('HH:mm')}
          </span>
          <span className="mx-1">{props.recurrentSchedule.dows.join(',')}</span>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          color="red"
          appearance="primary"
          onClick={() => deleteRecurrentSchedule(props.recurrentSchedule)}
          // 削除完了までモーダルを開いたままにするため、二重送信を防ぐ
          disabled={isDeleting}
        >
          {isDeleting ? '削除中...' : '削除する'}
        </Button>
        <Button onClick={props.onClose} appearance="subtle">
          キャンセル
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
